/*
  Waterbeads product page behaviour. Two small jobs that Dawn's own scripts don't
  cover; everything else on the page (variant re-render, AJAX add to cart, gallery,
  zoom lightbox) is still Dawn's product-info.js / product-form.js / media-gallery.js.

  1. Keep our own variant-dependent bits in sync.
     product-info.js already fetches the re-rendered section HTML on every variant
     change and copies a fixed list of ids out of it (price, SKU, inventory, …). It
     then publishes PUB_SUB_EVENTS.variantChange with that HTML. We listen for it and
     do the same for anything marked [data-wb-swap] (the fill note, the instalment
     text), and mirror the add-to-cart button's disabled state onto Buy it now.
     No Dawn file is edited to make this work.

  2. "Buy it now". Adds the current form's contents to the cart, then goes to
     checkout. It reads the same <form> as the add-to-cart button (quantity and
     variant inputs point at it via their `form` attribute), so quantity and the
     selected variant are always whatever the shopper has chosen.
*/

(() => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const { sectionId, html } = data || {};
      if (!sectionId || !html) return;

      const root = document.getElementById(`MainProduct-${sectionId}`);
      if (!root) return;

      root.querySelectorAll('[data-wb-swap]').forEach((element) => {
        const source = html.getElementById(element.id);
        if (source) element.innerHTML = source.innerHTML;
      });

      const buyNow = root.querySelector('[data-wb-buy-now]');
      if (buyNow) {
        const addButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
        buyNow.disabled = addButton ? addButton.hasAttribute('disabled') : true;
      }
    });
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wb-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

    const form = document.getElementById(button.dataset.formId);
    if (!form) return;

    // Let the browser show its own message for an invalid quantity, as it would
    // for the add-to-cart button.
    if (!form.reportValidity()) return;

    const errorWrapper = button.closest('.wb-buy')?.querySelector('.product-form__error-message-wrapper');
    const errorMessage = errorWrapper?.querySelector('.product-form__error-message');
    if (errorWrapper) errorWrapper.toggleAttribute('hidden', true);

    button.setAttribute('aria-busy', 'true');

    try {
      const body = new FormData(form);
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        if (errorWrapper && errorMessage) {
          errorMessage.textContent = result.description || result.message || '';
          errorWrapper.toggleAttribute('hidden', false);
        }
        button.removeAttribute('aria-busy');
        return;
      }

      window.location.assign(button.dataset.checkoutUrl);
    } catch (error) {
      console.error(error);
      button.removeAttribute('aria-busy');
    }
  });
})();
